<template>
  <div class="mb-16 font-normal">
    <div class="heading-folder-name mb-12 flex items-center justify-start">
      <zt-avatar v-if="flagToShowName && nameFolder !=='' && !errors.has('nb-folder')" :text="nameFolder[0]" size="38px" color="" class="mr-4 flex-none" />
      <zt-avatar v-else text="N" size="38px" color="" class="mr-4 flex-none" />
      <h2 class="font-medium" v-if="flagToShowName && nameFolder !=='' && !errors.has('nb-folder')"> {{nameFolder}} </h2>
      <h2 class="font-medium" v-else>
        {{ $t('message.abm.folders.settings.folderName.default') }}
      </h2>
    </div>
    <h2 class="custom-title custom-color-gray font-medium mb-4">
      {{ $t('message.abm.folders.settings.folderName.question') }}
    </h2>
    <p class="custom-legend text-zt-dark-300 mb-4">
      {{ $t('message.abm.folders.settings.folderName.description') }}
    </p>
    <div class="w-full custom-input">
      <zt-input
        ref="ztInputName"
        v-model="nameFolder"
        class="w-full"
        name="nb-folder"
        :color="errorText ? 'danger' : 'primary'"
        v-validate="{ required: true, min: 3, max:150 , regex: /^[a-zA-Z0-9\\s\\:ñÑàèìòùáéíóúäëïöü\- ]*$/ }"
        outlined
        @focusout="flagToShowName = true"
        :label='$t("message.abm.folders.folderName")'
        data-vs-input="nameFolder"
      />
      <span class="text-zt-danger absolute text-base pt-1" v-show="errorText">
        {{ errorText }}
      </span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FolderName',
  inject: ['stateFolder', 'setParams', 'resetError'],
  data() {
    return {
      nameFolder:'',
      flagToShowName:false
    }
  },
  computed: {
    errorText() {
      if (this.stateFolder.error.code === '10036') {
        return this.stateFolder.error.message
      }
      if (this.errors.first('nb-folder')) {
        return this.errors.first('nb-folder')
      }
      return ''
    }
  },
  created() {
    this.nameFolder = this.stateFolder.params.name
    this.flagToShowName = this.nameFolder !== ''
  },
  watch: {
    errorText() {
      if (this.$refs.ztInputName.$el && this.errorText) {
        this.$refs.ztInputName._data.isFocused = true
      }
    },
    nameFolder() {
      if (this.errorText) this.resetError()
      setTimeout(() => {
        if (!this.errors.has('nb-folder')) {
          this.setParams({
            name: this.nameFolder
          })
        } else {
          this.setParams({
            name: ''
          })
        }
      }, 10)
    }
  }
}
</script>
<style scoped lang="scss">
.custom-color-gray {
  color: #575757;
}
.custom-title {
  font-size: 1.5rem;
}
.custom-legend {
  font-size: 1.125rem;
}
.custom-input {
  ::v-deep {
    .zt-label {
      font-size: 1.125rem;
      margin: 0;
    }
    .zt-input {
      font-size: 1.125rem;
    }
  }
}
.heading-folder-name {
  h2 {
    font-size: 24px;
    color: #2D2D2D;
  }
  .button-delete {
    border: 0 none;
    background: #FFF;
    font-size: 24px;
    line-height: 24px;
  }
  ::v-deep {
    .zt-avatar span {
      font-size: 24px;
      transform: scale(1) !important;
    }
  }
}
</style>
